import { ELEMENT_TYPE } from "./constants";
// 把html元素转成自定义
/**
 * @param domElem HTML 对应的 DOM Element
 * @param children 子节点
 * @param editor editor 实例
 * @returns 元素数据结构，如上文的 Resume
 */
const parseHtml = (domElem, children) => {
  const url = domElem.getAttribute("data-url");
  // 生成元素数据结构
  const myResume = {
    type: ELEMENT_TYPE,
    url,
    children,
  };
  return myResume;
};

// 编辑器解析html配置
export const parseHtmlConfig = {
  selector: `div[data-w-e-type="${ELEMENT_TYPE}"]`, // CSS 选择器，匹配特定的 HTML 标签
  parseElemHtml: parseHtml,
};
